<template>
  <v-menu
    offset-y
    nudge-top="-85"
    content-class="notif-dropdown-menu"
    :close-on-content-click="false"
    @input="handleMenuInput"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        color="transparent"
        depressed
        fab
        dark
        v-bind="attrs"
        v-on="on"
        width="fit-content"
        height="fit-content"
        class="mr-0 mr-sm-5 notif-bell-btn"
        :class="activatorClass"
      >
        <v-badge
          color="red"
          class="ml-3 mb-1 notif-bell-badge"
          :class="badgeClass"
          :content="notificationsCount"
          v-if="notificationsCount > 0"
        />
        <v-icon
          v-if="activatorIcon"
          class="notif-bell-btn__icon"
          :title="title"
        >
          {{ activatorIcon }}
        </v-icon>
        <svg
          v-else
          xmlns="http://www.w3.org/2000/svg"
          width="24.052"
          height="24.052"
          viewBox="0 0 20.552 21"
        >
          <g transform="translate(1 1)">
            <g>
              <line
                x2="3"
                transform="translate(8 19)"
                fill="none"
                stroke="#fff"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
              />
              <path
                d="M22.552,19.179H4a3.044,3.044,0,0,0,1.687-2.732V11.59A7.59,7.59,0,0,1,13.276,4h0a7.59,7.59,0,0,1,7.59,7.59v4.857a3.044,3.044,0,0,0,1.687,2.732Z"
                transform="translate(-4 -4)"
                fill="none"
                stroke="#fff"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
              />
            </g>
          </g>
        </svg>
      </v-btn>
    </template>

    <div class="notif-panel" :class="{ 'notif-panel--dark': isDark }">
      <div class="notif-panel__header">
        <div class="notif-panel__header-title">
          <span class="notif-panel__header-icon" aria-hidden="true">
            <v-icon v-if="headerIcon" small>{{ headerIcon }}</v-icon>
            <svg v-else xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"/>
            </svg>
          </span>
          <span>{{ title }}</span>
        </div>
        <span v-if="notificationsCount > 0" class="notif-panel__count">
          {{ notificationsCount }} 
        </span>
      </div>

      <div v-if="displayNotifications.length" class="notif-panel__list">
        <div
          v-for="(notif, index) in displayNotifications"
          :key="notif.id || index"
          class="notif-card"
          :class="{
            'notif-card--unread': !notif.is_read,
            'notif-card--read': notif.is_read,
          }"
          @click="handleCardClick(notif)"
        >
          <div class="notif-card__accent" aria-hidden="true" />

          <div class="notif-card__body">
            
            <p class="notif-card__text">{{ notif.value }}</p>
            <div class="notif-card__top">
              <!-- <span
                class="notif-card__status"
                :class="notif.is_read ? 'notif-card__status--read' : 'notif-card__status--unread'"
              >
                <span class="notif-card__status-dot" aria-hidden="true" />
                {{ notif.is_read ? 'مقروء' : 'غير مقروء' }}
              </span> -->
              <span class="notif-card__date">
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
                  <line x1="16" y1="2" x2="16" y2="6"/>
                  <line x1="8" y1="2" x2="8" y2="6"/>
                  <line x1="3" y1="10" x2="21" y2="10"/>
                </svg>
                {{ notif.notif_date }}
              </span>
            </div>
          </div>

          <button
            type="button"
            class="notif-card__delete"
            :title="deleteTitle"
            @click.prevent.stop="$emit('mark-as-read', notificationPayload(notif))"
          >
            <img src="/img/4.d72f4c49.svg" alt="" />
          </button>
        </div>
      </div>

      <div v-else class="notif-panel__empty">
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" opacity="0.4">
          <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/>
          <path d="M13.73 21a2 2 0 0 1-3.46 0"/>
        </svg>
        <p>{{ emptyText }}</p>
      </div>

      <router-link
        v-if="notificationsCount > 0"
        :to="{ name: moreRouteName }"
        class="notif-panel__footer"
      >
        {{ moreLabel }}
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <polyline points="15 18 9 12 15 6"/>
        </svg>
      </router-link>
    </div>
  </v-menu>
</template>

<script>
import moment from 'moment';

/** Static placeholders until backend returns notif_date + is_read */
const STATIC_NOTIF_DATES = [
  '2025-07-03',
  '2025-06-28',
  '2025-06-15',
  '2025-06-01',
  '2025-05-20',
];

export default {
  name: 'NotificationDropdownMenu',
  props: {
    notifications: {
      // type: Object,
      default: () => ({ notifications: [], notifications_count: 0 }),
    },
    isDark: {
      type: Boolean,
      default: false,
    },
    resolveRoute: {
      type: Function,
      required: true,
    },
    moreRouteName: {
      type: String,
      default: 'TheNotifc',
    },
    title: {
      type: String,
      default: 'الإشعارات',
    },
    emptyText: {
      type: String,
      default: 'لا توجد إشعارات جديدة',
    },
    moreLabel: {
      type: String,
      default: 'عرض المزيد',
    },
    deleteTitle: {
      type: String,
      default: 'حذف الإشعار',
    },
    activatorIcon: {
      type: String,
      default: '',
    },
    headerIcon: {
      type: String,
      default: '',
    },
    activatorClass: {
      type: [String, Object, Array],
      default: '',
    },
    badgeClass: {
      type: [String, Object, Array],
      default: '',
    },
    markOnCardClick: {
      type: Boolean,
      default: false,
    },
    markPayload: {
      type: String,
      default: 'id',
      validator: (value) => ['id', 'item'].includes(value),
    },
  },
  computed: {
    notificationsCount() {
      return this.notifications?.notifications_count || 0;
    },
    displayNotifications() {
      const list = this.notifications?.notifications || [];
      return list.map((notif, index) => this.enrichNotification(notif, index));
    },
  },
  methods: {
    handleMenuInput(isOpen) {
      if (isOpen) {
        this.$emit('menu-open');
      }
    },
    notificationPayload(notif) {
      return this.markPayload === 'item' ? notif : notif.id;
    },
    handleCardClick(notif) {
      if (this.markOnCardClick) {
        this.$emit('mark-as-read', this.notificationPayload(notif));
      }

      const route = this.resolveRoute(notif);
      if (route) {
        this.$router.push(route).catch(() => {});
      }
    },
    formatNotificationDateTime(value) {
      if (value === null || value === undefined || value === '') return '';

      const parsed = moment(
        value,
        [
          moment.ISO_8601,
          'YYYY-MM-DD HH:mm:ss',
          'YYYY-MM-DD HH:mm',
          'YYYY-MM-DD',
          'DD-MM-YYYY HH:mm:ss',
          'DD-MM-YYYY HH:mm',
        ],
        true
      );

      if (parsed.isValid()) {
        return parsed.locale('en').format('YYYY-MM-DD hh:mm A');
      }

      const fallback = moment(value);
      return fallback.isValid() ? fallback.locale('en').format('YYYY-MM-DD hh:mm A') : String(value);
    },
    enrichNotification(notif, index) {
      const hasBackendRead = notif.is_read !== undefined && notif.is_read !== null;

      let notif_date = notif.notif_date;
      if (!notif_date && notif.notification_date) {
        notif_date = this.formatNotificationDateTime(notif.notification_date);
      } else if (notif_date) {
        notif_date = this.formatNotificationDateTime(notif_date);
      }
      if (!notif_date) {
        // notif_date = STATIC_NOTIF_DATES[index % STATIC_NOTIF_DATES.length];
      }

      return {
        ...notif,
        notif_date,
        // TODO: replace static alternation when API sends is_read
        is_read: hasBackendRead ? Boolean(notif.is_read) : index % 2 === 0,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.notif-bell-btn {
  position: relative;
}

.notif-bell-badge {
  position: absolute;
  right: -5px;
}

.notif-panel {
  width: min(340px, 92vw);
  max-height: 360px;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 12px 40px rgba(63, 14, 64, 0.18), 0 4px 12px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(63, 14, 64, 0.08);

  &--dark {
    background: linear-gradient(165deg, #1e1e2e 0%, #16161f 100%);
    border-color: rgba(255, 255, 255, 0.08);
    box-shadow: 0 16px 48px rgba(0, 0, 0, 0.45), 0 0 0 1px rgba(1, 127, 133, 0.12);

    .notif-panel__header {
      border-bottom-color: rgba(255, 255, 255, 0.08);
      color: #f0f0f5;
    }

    .notif-panel__count {
      background: rgba(1, 127, 133, 0.2);
      color: #5eead4;
    }

    .notif-card--unread {
      background: rgba(1, 127, 133, 0.1);
      border-color: rgba(1, 127, 133, 0.35);

      .notif-card__accent {
        background: linear-gradient(180deg, #017f85, #5eead4);
      }
    }

    .notif-card--read {
      background: rgba(255, 255, 255, 0.04);
      border-color: rgba(255, 255, 255, 0.06);

      .notif-card__accent {
        background: rgba(255, 255, 255, 0.15);
      }
    }

    .notif-card__text {
      color: #e8e8ef;
    }

    .notif-card__date {
      color: #9ca3af;
    }

    .notif-card__status--read {
      background: rgba(255, 255, 255, 0.08);
      color: #9ca3af;
    }

    .notif-card__status--unread {
      background: rgba(1, 127, 133, 0.25);
      color: #5eead4;
    }

    .notif-card__delete:hover {
      background: rgba(255, 255, 255, 0.1);
    }

    .notif-panel__empty {
      color: #9ca3af;
    }

    .notif-panel__footer {
      background: rgba(1, 127, 133, 0.15);
      color: #5eead4;
      border-top-color: rgba(255, 255, 255, 0.08);

      &:hover {
        background: rgba(1, 127, 133, 0.28);
      }
    }
  }

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 12px 7px;
    border-bottom: 1px solid #ebebeb;
    color: #3f0e40;
    flex-shrink: 0;
  }

  &__header-title {
    display: flex;
    align-items: center;
    gap: 6px;
    font-weight: 800;
    font-size: 14px;
  }

  &__header-icon {
    display: flex;
    align-items: center;
    color: #017f85;
  }

  &__count {
    font-size: 11px;
    font-weight: 700;
    padding: 2px 8px;
    border-radius: 20px;
    background: rgba(63, 14, 64, 0.08);
    color: #3f0e40;
  }

  &__list {
    overflow-y: auto;
    padding: 6px 8px;
    display: flex;
    flex-direction: column;
    gap: 5px;
    flex: 1;
    min-height: 0;

    &::-webkit-scrollbar {
      width: 5px;
    }
    &::-webkit-scrollbar-thumb {
      background: rgba(63, 14, 64, 0.2);
      border-radius: 4px;
    }
  }

  &__empty {
    padding: 20px 12px;
    text-align: center;
    color: #9ca3af;

    p {
      margin: 6px 0 0;
      font-size: 13px;
    }
  }

  &__footer {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    padding: 8px;
    font-weight: 700;
    font-size: 13px;
    color: #017f85;
    background: rgba(1, 127, 133, 0.08);
    border-top: 1px solid #ebebeb;
    text-decoration: none;
    flex-shrink: 0;
    transition: background 0.2s ease;

    &:hover {
      background: rgba(1, 127, 133, 0.16);
    }

    svg {
      transform: scaleX(-1);
    }
  }
}

.notif-card {
  display: flex;
  align-items: stretch;
  gap: 0;
  border-radius: 8px;
  border: 1px solid #ebebeb;
  text-decoration: none;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
  overflow: hidden;
  position: relative;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 14px rgba(63, 14, 64, 0.1);
  }

  &--unread {
    background: rgba(1, 127, 133, 0.06);
    border-color: rgba(1, 127, 133, 0.25);

    .notif-card__accent {
      background: linear-gradient(180deg, #017f85, #40be72);
    }
  }

  &--read {
    background: #fafafa;

    .notif-card__accent {
      background: #d1d5db;
    }
  }

  &__accent {
    width: 4px;
    flex-shrink: 0;
  }

  &__body {
    flex: 1;
    padding: 6px 6px 6px 10px;
    min-width: 0;
  }

  &__top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 6px;
    margin-bottom: 3px;
  }

  &__status {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-size: 10px;
    font-weight: 700;
    padding: 2px 6px;
    border-radius: 20px;
    white-space: nowrap;

    &--unread {
      background: rgba(1, 127, 133, 0.15);
      color: #017f85;

      .notif-card__status-dot {
        background: #017f85;
        box-shadow: 0 0 6px rgba(1, 127, 133, 0.6);
      }
    }

    &--read {
      background: #f3f4f6;
      color: #6b7280;

      .notif-card__status-dot {
        background: #9ca3af;
      }
    }
  }

  &__status-dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    flex-shrink: 0;
  }

  &__date {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-size: 11px;
    font-weight: 500;
    color: #9ca3af;
    white-space: nowrap;
  }

  &__text {
    margin: 0;
    font-size: 13px;
    line-height: 1.4;
    color: #2c2c2c;
    font-weight: 500;
    word-break: break-word;
  }

  &__delete {
    flex-shrink: 0;
    align-self: center;
    margin: 0 5px;
    width: 26px;
    height: 26px;
    border: none;
    background: transparent;
    border-radius: 8px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.15s ease;

    img {
      width: 14px;
      opacity: 0.55;
    }

    &:hover {
      background: rgba(63, 14, 64, 0.08);

      img {
        opacity: 1;
      }
    }
  }
}
</style>

<style lang="scss">
.notif-dropdown-menu {
  border-radius: 12px !important;
  overflow: visible !important;
  box-shadow: none !important;
  background: transparent !important;
  z-index: 200 !important;
  min-width: 0 !important;
  /* Flush under navbar / bell — keep agent name visible in the bar */
  transform: translateY(-64px) !important;
}
</style>
